import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-qb-action-dropdown',
  templateUrl: './qb-action-dropdown.component.html',
  styleUrls: ['./qb-action-dropdown.component.css']
})
export class QbActionDropdownComponent {
  @Input() source: any;
  @Input() invoice!: any;
  @Input() customer!: any;
  @Input() service!: any;
  @Input() vendor!: any;
  @Input() bill!: any;
  @Input() billPayment!: any;
  @Input() payment!: any;
  @Input() canPay = false;
  @Output() download = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() send = new EventEmitter<any>();
  @Output() detail = new EventEmitter<any>();
  @Output() pullFrom = new EventEmitter<any>();
  @Output() pushTo = new EventEmitter<any>();
  @Output() pay = new EventEmitter<any>();
  @Output() receivePayment = new EventEmitter<any>();
  @Output() voidPayment = new EventEmitter<any>();
  @Output() deleteBillPayment = new EventEmitter<any>();
  @Output() deletePayment = new EventEmitter<any>();
}
